// Libs
import { handleMessageEmit } from '@/methods/message/handleMessageEmit'

// Constants
import { WS_EVENT_LIVE_SHOW } from '@/constants/socketEvent'

export interface RoomHandUpParams {
  socket: any
}

export const getRoomMicOnList = ({ socket }: RoomHandUpParams) => {
  handleMessageEmit({ socket, content: { sid: WS_EVENT_LIVE_SHOW.sid, ssid: WS_EVENT_LIVE_SHOW.connect_list } })
}
